import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.MediaAboutUs.heading',
    defaultMessage: 'Media o nas'
  },
  lastAdded: {
    id: 'views.MediaAboutUs.lastAdded',
    defaultMessage: 'OSTATNIO DODANE'
  },
  earlier: {
    id: 'views.MediaAboutUs.earlier',
    defaultMessage: 'WCZEŚNIEJSZE'
  },
  categories: {
    id: 'views.MediaAboutUs.categories',
    defaultMessage: 'KATEGORIE'
  },
  nothingToShow: {
    id: 'views.MediaAboutUs.nothingToShow',
    defaultMessage: 'Brak artykułów do wyświetlenia'
  },
  taxonomyAll: {
    id: 'views.MediaAboutUsView.categories.all',
    defaultMessage: 'Wszystkie'
  },
  showMore: {
    id: 'views.MediaAboutUsView.showMore',
    defaultMessage: 'WYŚWIETL WIĘCEJ...'
  }
});



// WEBPACK FOOTER //
// ./src/views/MediaAboutUs/MediaAboutUsView.intl.js